
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load pages
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const WorkshopsPage = lazy(() => import('../pages/workshops/page'));
const CafePage = lazy(() => import('../pages/cafe/page'));
const BusStationPage = lazy(() => import('../pages/bus-station/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsConditionsPage = lazy(() => import('../pages/terms-conditions/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Loading component
const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-screen">
    <div>Loading...</div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<LoadingFallback />}><HomePage /></Suspense>,
  },
  {
    path: '/about',
    element: <Suspense fallback={<LoadingFallback />}><AboutPage /></Suspense>,
  },
  {
    path: '/workshops',
    element: <Suspense fallback={<LoadingFallback />}><WorkshopsPage /></Suspense>,
  },
  {
    path: '/cafe',
    element: <Suspense fallback={<LoadingFallback />}><CafePage /></Suspense>,
  },
  {
    path: '/bus-station',
    element: <Suspense fallback={<LoadingFallback />}><BusStationPage /></Suspense>,
  },
  {
    path: '/contact',
    element: <Suspense fallback={<LoadingFallback />}><ContactPage /></Suspense>,
  },
  {
    path: '/terms-conditions',
    element: <Suspense fallback={<LoadingFallback />}><TermsConditionsPage /></Suspense>,
  },
  {
    path: '/privacy-policy',
    element: <Suspense fallback={<LoadingFallback />}><PrivacyPolicyPage /></Suspense>,
  },
  {
    path: '*',
    element: <Suspense fallback={<LoadingFallback />}><NotFoundPage /></Suspense>,
  },
];

export default routes;
